import type {
  AggregatedDiscountDto,
  LabelDto,
} from '~/models/ListingProduct.api.model';

export const labelColorClass = (color: string | undefined) => {
  switch (color) {
    case 'campaign': {
      return 'bg-label-campaign';
    }
    case 'popular': {
      return 'bg-label-popular';
    }
    case 'news': {
      return 'bg-label-news';
    }
    case 'few-left': {
      return 'bg-label-few-left';
    }
    case 'black': {
      return 'bg-label-black';
    }
    case 'done': {
      return 'bg-label-done';
    }
    case 'beg': {
      return 'bg-surface-success';
    }
    default: {
      return 'bg-label-campaign';
    }
  }
};

export const general_mapDiscountsToLabels = (
  discounts: AggregatedDiscountDto[],
): LabelDto[] => {
  const nonEmptyDiscounts = discounts.filter(
    (discount) => !!discount.LabelText && discount.LabelText.trim() !== '',
  );

  const labels: LabelDto[] = nonEmptyDiscounts.map((discount) => ({
    Text: discount.LabelText,
    Color: discount.LabelColor,
  }));

  const uniqueLabels = Array.from(
    new Set(labels.map((label) => JSON.stringify(label))),
  ).map((jsonString) => JSON.parse(jsonString)) as LabelDto[];

  return uniqueLabels;
};
